// Standard Library imports
import React, { useState, useEffect } from 'react';

// External library imports

// Internal module imports
import CurrentEvents from './CurrentEvents';
import TabsComponent from '../../../../components/Tabs/Tabs';
import HistoryEvents from './HistoryEvents';
import OverviewEvents from './OverviewEvents';


const BessMonitoring = ({ queryParamsData, updateQueryParams, admins }) => {

    const [selectedIndex, setSelectedIndex] = useState(queryParamsData.subTab ? queryParamsData.subTab : 0);

    let tabs = [
        {
            name: 'Overview',
            component: (
                <>
                    <OverviewEvents admins={admins} queryParamsData={queryParamsData} updateQueryParams={updateQueryParams} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Current',
            component: (
                <>
                    <CurrentEvents admins={admins} queryParamsData={queryParamsData} updateQueryParams={updateQueryParams} />
                </>
            ),
            tabId: 2,
        },
        {
            name: 'History',
            component: (
                <>
                    <HistoryEvents admins={admins} queryParamsData={queryParamsData} updateQueryParams={updateQueryParams} />
                </>
            ),
            tabId: 3,
        },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                    updateQueryParams('subTab', index);
                }}
            />
        </div>
    );
};

export default BessMonitoring;
